import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from "@angular/router";
import { LeagueManagementDataStore } from "@store";
import { inject } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { League, LeagueEvents } from "@model";

export const LeagueManagementInitResolver: ResolveFn<boolean> =
    (route: ActivatedRouteSnapshot, _: RouterStateSnapshot,
     store: LeagueManagementDataStore = inject(LeagueManagementDataStore)): Observable<boolean> => {
        const leagueId = +route.queryParams['leagueId'];
        return store.preloadAll(leagueId).pipe(
            map(() => true)
        );
    };

export const LeagueManagementLeagueResolver = LeagueManagementDataStore.on<LeagueManagementDataStore, League>(s => s.currentLeague$);
export const LeagueManagementEventsResolver = LeagueManagementDataStore.on<LeagueManagementDataStore, LeagueEvents>(s => s.leagueEvents$);